var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"size":"small","placeholder":_vm.$t('input.placeholder.please_input')},model:{value:(_vm.qty),callback:function ($$v) {_vm.qty=$$v},expression:"qty"}})
}
var staticRenderFns = []

export { render, staticRenderFns }